/**
 * @generated SignedSource<<15e975f4c44947d385afb2c7731cc564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettingsResetDomainLockMutation$variables = {
  ujID: number;
};
export type selfServiceSettingsResetDomainLockMutation$data = {
  readonly resetJourneyScribeDomainLock: {
    readonly userJourney: {
      readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment">;
    } | null;
  } | null;
};
export type selfServiceSettingsResetDomainLockMutation = {
  response: selfServiceSettingsResetDomainLockMutation$data;
  variables: selfServiceSettingsResetDomainLockMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ujID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ujID",
    "variableName": "ujID"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceSettingsResetDomainLockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetJourneyScribeDomainLockMutation",
        "kind": "LinkedField",
        "name": "resetJourneyScribeDomainLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "selfServiceSettings_mainSettingsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selfServiceSettingsResetDomainLockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResetJourneyScribeDomainLockMutation",
        "kind": "LinkedField",
        "name": "resetJourneyScribeDomainLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutoff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutOffOK",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertOnSlow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingDomainLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeJourneyType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e11319c3f8fc09d6464dcdcd5f61cb6",
    "id": null,
    "metadata": {},
    "name": "selfServiceSettingsResetDomainLockMutation",
    "operationKind": "mutation",
    "text": "mutation selfServiceSettingsResetDomainLockMutation(\n  $ujID: Int!\n) {\n  resetJourneyScribeDomainLock(ujID: $ujID) {\n    userJourney {\n      ...selfServiceSettings_mainSettingsFragment\n      id\n    }\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n  journeyScribeStartingDomain\n  journeyScribeStartingDomainLocked\n  journeyScribeStartingURL\n  journeyScribeJourneyType\n}\n"
  }
};
})();

(node as any).hash = "bd119d5ac3fcb03a6ff1364423577c09";

export default node;
